module.exports = __webpack_public_path__ + "static/sofa-e188054df81ef9a48f24d4ea909b809a.webp";